<template>
<!-- 店铺数据 -->
<section class="viewContainer">
  <!-- 选择栏 -->
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="本店客户数据" name="fifth"/>
    <el-tab-pane label="店铺扫码记录" name="first"/>
    <el-tab-pane label="分享浏览数据" name="second"/>
    <el-tab-pane label="员工拉新数据" name="third"/>
    <el-tab-pane label="店铺浏览数据" name="fourth"/>
  </el-tabs>
  
  <div class="main_container">
    <div class="fuji" @click="show3 = !show3">
      <div class="goodslist1">
        <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
      </div>
      <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
    </div>
    <el-collapse-transition>
      <div v-show="show3">
      <!-- 本店客户数据 -->
      <el-form class="findform" v-show="activeName=='fifth'">
        <el-form-item label="活跃时间：" style="display:flex;width:25%;">
          <el-date-picker type="daterange" v-model="value5" unlink-panels @change="changeTime5" style="width: 90%;"
          range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
        </el-form-item>
        <el-form-item label="来源渠道：" style="display:flex;width:25%;">
          <el-select v-model="lyqd" placeholder="请选择" style="width: 90%;">
            <el-option v-for="(item,index) in lyqdOptions" :key="index" :value="item.sourceID" :label="item.sourceName"/>
          </el-select>
        </el-form-item>
        <el-form-item label="客户属性：" style="display:flex;width:25%;" v-show="tabPosition==0">
          <el-select v-model="khsx" placeholder="请选择" style="width: 90%;">
            <el-option v-for="(item,index) in khsxOptions" :key="index" :value="item.attribID" :label="item.attribName"/>
          </el-select>
        </el-form-item>
        <div>
          <el-button type="danger" @click="onSubmit">查询</el-button>
          <el-button type="danger" @click="buyingCustomers('')" v-show="tabPosition==1">购买客户</el-button>
        </div>
      </el-form>
      <!-- 店铺扫码记录 -->
      <el-form class="findform" v-show="activeName=='first'">
        <el-form-item label="" style="display:flex;width:25%;">
          <el-date-picker type="daterange" v-model="value1" unlink-panels @change="changeTime1"
          range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- 分享浏览数据 -->
      <el-form class="findform" v-show="activeName=='second'">
        <el-form-item style="display:flex;width:25%" label="">
          <el-input v-model="partnerPhone" placeholder="员工昵称·员工手机号" maxlength="11" style="width: 90%;"/>
        </el-form-item>
        <el-form-item style="display:flex;width:25%;" label="">
          <el-date-picker type="daterange" v-model="value2" unlink-panels @change="changeTime2"
          range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- 员工拉新数据 -->
      <el-form class="findform" v-show="activeName=='third'">
        <el-form-item style="display:flex;width:25%" label="">
          <el-input v-model="staffPhone" placeholder="员工手机号码" maxlength="11" style="width: 90%;"/>
        </el-form-item>
        <el-form-item style="display:flex;width:25%;" label="">
          <el-date-picker v-model="value3" type="daterange" unlink-panels range-separator="至"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" @change="changeTime3"/>
        </el-form-item>
        <div>
          <el-button type="danger" @click="onSubmit">查询</el-button>
          <el-button type="danger" @click="fnReset">重置</el-button>
          <el-button type="danger" @click="onExport">导出</el-button>
        </div>
      </el-form>
      <!-- 店铺浏览数据 -->
      <el-form class="findform" v-show="activeName=='fourth'">
        <el-form-item style="display:flex;width:25%">
          <el-input v-model="yhsjhPhone" placeholder="用户手机号" maxlength="11" style="width: 90%;"/>
        </el-form-item>
        <el-form-item style="display:flex;width:25%;">
          <el-date-picker type="daterange" v-model="value4" unlink-panels @change="changeTime4"
          range-separator="至"  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"/>
        </el-form-item>
        <el-form-item>
          <el-button type="danger" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      </div>
    </el-collapse-transition>
  </div>
  
  <!-- 本店客户数据 -->
  <div class="main_container" v-show="activeName=='fifth'">
    <el-radio-group v-model="tabPosition" @change="changeTheme" style="margin: 10px 0 10px 10px;">
      <el-radio-button label="0">全部</el-radio-button>
      <el-radio-button label="1">未付费客户</el-radio-button>
    </el-radio-group>
    <span style="margin-left:20px;color: #999;">温馨提示：客户手机号带*号，请进行购买后再查看完整手机号码</span>
    <b style="margin:20px 20px 0 0;float:right;color: #F56C6C;">{{tabPosition == 0?'本店客户：':'未付费客户：'}} {{totalRowsCountFive}}人</b>
    <div class="table_container">
      <el-table :data="bdkhsjList" class="invoice_tab" stripe border @selection-change="handleSelectionChange">
        <el-table-column type="selection" align="center" v-if="tabPosition == 1"/>
        <el-table-column label="序号" align="center" width="60">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="客户手机号" align="center">
          <template scope="scope">
            <span>{{scope.row.phone}}</span>
            <!-- <span v-show="scope.row.status != 2">{{scope.row.phone}}</span>
            <span v-show="scope.row.status == 2" style="color:#409EFF;" @click="seePhone(scope.row)">查看电话号码 </span> -->
          </template>
        </el-table-column>
        <el-table-column label="最近活跃时间" align="center">
          <template scope="scope">{{scope.row.lastactivitime}}</template>
        </el-table-column>
        <el-table-column label="来源渠道" align="center">
          <template scope="scope">{{scope.row.sourcename}}</template>
        </el-table-column>
        <el-table-column label="是否本店消费" align="center">
          <template scope="scope">{{scope.row.isconsume==0?'否':'是'}}</template>
        </el-table-column>
        <el-table-column label="客户属性" align="center">
          <template scope="scope">{{scope.row.statusname}}</template>
        </el-table-column>
        <el-table-column label="浏览本店次数" align="center">
          <template scope="scope">{{scope.row.browsecount}}</template>
        </el-table-column>
        <el-table-column label="备注" align="center">
          <template scope="scope">{{scope.row.remark}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="buyingCustomers(scope.row)" class="handle" v-show="scope.row.status == 1"> <i class="el-icon-shopping-cart-full"/> 购买 </span>
            <span @click="handleSeeLlnr(scope.row)" class="handle"> <i class="el-icon-view"/> 查看浏览内容 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="currentChangeFive"
      :current-page="pageIndexFive" :page-size="10" :total="totalRowsCountFive" style="margin:10px 0;float:right"/>
    </div>
  </div>
  <!-- 店铺扫码记录 -->
  <div class="main_container" v-show="activeName=='first'">
    <section class="model_section">
      <p class="model_top_title">店铺扫码记录</p>
    </section>
    <div class="table_container">
      <el-table :data="dpsmjlList" stripe border>
        <el-table-column label="序号" align="center" width="68px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="扫码日期" align="center">
          <template scope="scope">{{scope.row.date}}</template>
        </el-table-column>
        <el-table-column label="扫码时间" align="center">
          <template scope="scope">{{scope.row.time}}</template>
        </el-table-column>
        <el-table-column label="用户昵称" align="center">
          <template scope="scope">{{scope.row.nikeName}}</template>
        </el-table-column>
        <el-table-column label="用户手机号" align="center">
          <template scope="scope">{{scope.row.phone}}</template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handlePagingOne"
      :current-page="pageIndex1" :page-size="10" :total="totalRowsCount1" style="margin:10px 0;float:right"/>
    </div>
  </div>
  <!-- 分享浏览数据 -->
  <div class="main_container" v-show="activeName=='second'">
    <section class="model_section">
      <p class="model_top_title">分享浏览数据</p>
    </section>
    <div class="table_container">
      <el-table :data="ygfxhkList" stripe border>
        <el-table-column label="序号" align="center" width="68px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="员工昵称" align="center">
          <template scope="scope">{{scope.row.staffNikeName}}</template>
        </el-table-column>
        <el-table-column label="员工手机号" align="center">
          <template scope="scope">{{scope.row.staffPhone}}</template>
        </el-table-column>
        <el-table-column label="分享内容" align="center">
          <template scope="scope">{{scope.row.title}}</template>
        </el-table-column>
        <el-table-column label="用户昵称" align="center">
          <template scope="scope">{{scope.row.nikeName}}</template>
        </el-table-column>
        <el-table-column label="用户手机号" align="center">
          <template scope="scope">{{scope.row.phone}}</template>
        </el-table-column>
        <el-table-column label="查看分享日期" align="center">
          <template scope="scope">{{scope.row.date}}</template>
        </el-table-column>
        <el-table-column label="查看分享时间" align="center">
          <template scope="scope">{{scope.row.time}}</template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handlePagingTwo"
      :current-page="pageIndex2" :page-size="10" :total="totalRowsCount2" style="margin:10px 0;float:right"/>
    </div>
  </div>
  <!-- 员工拉新数据 -->
  <div class="main_container" v-show="activeName=='third'">
    <section class="model_section">
      <p class="model_top_title">员工拉新数据</p>
    </section>
    <div class="table_container">
      <el-table :data="yglxsjList" stripe border style="width: 100%" id="table">
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column prop="name" label="员工昵称" align="center"/>
        <el-table-column prop="phone" label="手机号码" align="center"/>
        <el-table-column label="拉新用户数" align="center">
          <template scope="scope">
            <span style="color:#409EFF;" @click="lxyhsClick(scope.row, 0)">{{scope.row.newUserCount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="会员" align="center">
          <template scope="scope">
            <span style="color:#409EFF;" @click="lxyhsClick(scope.row, 1)">{{scope.row.newUserVIPCount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易笔数" align="center">
          <template scope="scope">
            <span style="color:#409EFF;" @click="pullNewFun(scope.row.id,2)">{{scope.row.newUserOrderCount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="newUserOrderSum" label="交易金额(元)" align="center"/>
        <el-table-column prop="commission" label="佣金" align="center"/>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleTabEighth"
      :current-page="pageIndexEighth" :page-size="10" :total="totalRowsCountEighth" style="margin:10px 0;float:right"/>
    </div>
    <!-- 拉新用户数表 -->
    <div class="table_container" v-show="lxyhsShow">
      <p><b>{{ygnc}}拉新明细表</b></p>
      <el-table :data="lxyhsList" border style="width: 100%">
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column prop="name" label="用户昵称" align="center"/>
        <el-table-column prop="phone" label="手机号码" align="center"/>
        <el-table-column label="拉新用户数" align="center">
          <template scope="scope">
            <span style="color:#409EFF;" @click="pullNewFun(scope.row.id,3)">{{scope.row.newUserCount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易笔数" align="center">
          <template scope="scope">
            <span style="color:#409EFF;" @click="pullNewFun(scope.row.id,4)">{{scope.row.newUserOrderCount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="newUserOrderSum" label="交易金额(元)" align="center"/>
        <el-table-column label="分享被浏览次数" align="center">
          <template scope="scope">
            <span style="color:#409EFF;" @click="pullNewFun(scope.row.id,5)">{{scope.row.shareCount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="commission" label="佣金" align="center"/>
        <el-table-column prop="customTypeName" label="备注" align="center"/>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handlelxyhsList"
      :current-page="pageIndexLxyhs" :page-size="10" :total="totalRowsCountLxyhs" style="margin:10px 0;float:right"/>
    </div>
  </div>
  <!-- 店铺浏览数据 -->
  <div class="main_container" v-show="activeName=='fourth'">
    <section class="model_section">
      <p class="model_top_title">店铺浏览数据</p>
    </section>
    <div class="table_container">
      <el-table :data="dpllsjList" class="invoice_tab" stripe border>
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="用户手机号" align="center">
          <template scope="scope">{{scope.row.phone}}</template>
        </el-table-column>
        <el-table-column label="浏览次数" align="center">
          <template scope="scope">{{scope.row.readCount}}</template>
        </el-table-column>
        <el-table-column label="最后浏览时间" align="center">
          <template scope="scope">{{scope.row.lastTime}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="handleSeeLlmx(scope.row)" class="handle"> <i class="el-icon-view"/> 查看浏览明细 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndexFour" :page-size="10" :total="totalRowsCountFour" style="margin:10px 0;float:right"/>
    </div>
  </div>

  <!-- 会员&交易笔数&拉新用户数&交易笔数&分享被浏览次数 右侧抽屉组件 -->
  <el-drawer :title="titSix" custom-class="registrationRecord" :visible.sync="newUsersDrawer" direction="rtl" size="48%">
    <el-table :data="pullNewOrVipList" style="margin: 0px">
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column property="name" label="用户昵称" align="center"/>
      <template v-if="titSix == '交易笔数'">
        <el-table-column property="orderNo" label="订单号" align="center"/>
        <el-table-column property="cTime" label="交易时间" align="center"/>
        <el-table-column property="shopName" label="所属店铺" align="center"/>
        <el-table-column property="price" label="交易金额(元)" align="center"/>
      </template>
      <template v-if="lxyhspthyType == 3">
        <el-table-column property="phone" label="手机号码" align="center" key="1"/>
        <el-table-column property="newUserOrderCount" label="交易笔数" align="center" key="2"/>
        <el-table-column property="newUserOrderSum" label="交易金额(元)" align="center"/>
      </template>
      <template v-if="lxyhspthyType == 5">
        <el-table-column property="title" label="分享内容" align="center" key="1"/>
        <el-table-column property="phone" label="用户手机号" align="center" key="2"/>
        <el-table-column property="shareDate" label="查看分享日期" align="center" key="3"/>
        <el-table-column property="shareTime" label="查看分享时间" align="center" key="4"/>
      </template>
    </el-table>
    <!-- 会员&交易笔数&拉新用户数&交易笔数&分享被浏览次数-分页 -->
    <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
      <el-pagination layout="prev, pager, next" @current-change="handleTabSix"
      :current-page="pageIndexSix" :page-size="10" :total="totalRowsCountSix" style="float: right; margin-top: 10px"/>
    </el-col>
  </el-drawer>
  
  <!-- 查看浏览明细 右侧抽屉组件 -->
  <el-drawer title="查看浏览明细" custom-class="registrationRecord" :visible.sync="visibleSeeLlmx" size="48%">
    <el-table :data="seeLlmxList" style="margin: 0px">
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column property="title" label="浏览内容" align="center"/>
      <el-table-column property="time" label="浏览时间" align="center"/>
    </el-table>
    <!-- 查看浏览明细-分页 -->
    <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
      <el-pagination layout="prev, pager, next" @current-change="handleLlmx"
      :current-page="pageIndexLlmx" :page-size="10" :total="totalRowsCountLlmx" style="float: right; margin-top: 10px"/>
    </el-col>
  </el-drawer>
  
  <!-- 查看浏览内容 右侧抽屉组件 -->
  <el-drawer title="查看浏览内容" custom-class="registrationRecord" :visible.sync="visibleSeeLlnr" size="48%">
    <el-table :data="seeLlnrList" border>
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column property="title" label="浏览内容" align="center"/>
      <el-table-column property="time" label="浏览时间" align="center"/>
      <el-table-column property="readCount" label="浏览次数" align="center"/>
    </el-table>
    <!-- 查看浏览内容-分页 -->
    <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
      <el-pagination layout="prev, pager, next" @current-change="handleLlnr"
      :current-page="pageIndexLlnr" :page-size="10" :total="totalRowsCountLlnr" style="float: right; margin-top: 10px"/>
    </el-col>
  </el-drawer>
  
  <!-- 重要提示&温馨提示 -->
  <el-dialog :title='titlePhone' :visible.sync="visiblePhone" width="30%" center>
    <div style="text-align:center;" v-show="titlePhone == '重要提示'">
      <b style="margin: 10px 0 30px 0; font-size: 18px;">{{numPhone}}</b>
      <ul style="text-align: left;margin: 10px 0 30px 0;line-height: 22px;">
        <li>温馨提示：</li>
        <li>1.客户隐私号码3分钟内有效，请尽快拨打。</li>
        <li>2.隐私号码呼叫客户，通话费用0.06元/分钟；通话费费用账单每日23点进行结算。</li>
      </ul>
      <!-- <p style="margin: 10px 0 30px 0; font-size: 16px;">为保护客户隐私，此号码3分钟内有效，请尽快拨打。</p> -->
    </div>
    <div style="text-align:center;" v-show="titlePhone == '温馨提示'">
      <p style="margin: 10px 0 30px 0; font-size: 16px;">当前虚拟号码资源紧张，请稍后再试，如有问题请联系400-1577-588。</p>
    </div>
    <div style="text-align:center">
      <el-button type="danger" @click="visiblePhone = false">确定</el-button>
    </div>
  </el-dialog>

  <!-- 充值提示 (查看电话号码) -->
  <el-dialog title='充值提示' :visible.sync="priorityRecharge" width="25%" center>
    <p style="text-align:center;margin-bottom: 30px;">当前账户已欠费{{owemoney}}元，请先对账户充值再进行呼叫。</p>
    <div style="text-align:center">
      <el-button @click="priorityRecharge = false" style="width: 100px;">取消</el-button>
      <el-button type="danger" @click="quchongzhi()" style="width: 100px;">去充值</el-button>
    </div>
  </el-dialog>

  <!-- 请使用微信扫码支付 -->
  <el-dialog title='请使用微信扫码支付' :visible.sync="wxsmzfVisible" width="20%" center @closed="closeWxsmzf">
    <div class="wxsmzfClass">
      <P>{{wxsmzfJine}} 元</P>
      <img :src="wxSmzfImg"/>
    </div>
  </el-dialog>
  
  <!-- 购买提示 -->
  <el-dialog title='购买提示' :visible.sync="goumai" width="35%" center>
    <div style="text-align:center">
      <div style="margin-bottom: 20px;">本次共申请购买以下<b style="color: #F56C6C;">{{goumaiList.length}}</b>条客户数据，需支付<b style="color: #F56C6C;">{{zysj}}</b>元，点击“确定”后购买客户信息。</div>
      <el-table :data="goumaiList" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column prop="phone" label="客户手机号" align="center"/>
        <el-table-column prop="lastactivitime" label="最近活跃时间" align="center"/>
      </el-table>
    </div>
    <div style="text-align:center;margin-top: 20px;">
      <el-button @click="goumai = false">取消</el-button>
      <el-button type="danger" @click="handleGm(0)">确定</el-button>
    </div>
  </el-dialog>

  <!-- 充值提示 -->
  <el-dialog title='充值提示' :visible.sync="chongzhi" width="25%" center>
    <p style="text-align:center;margin-bottom: 30px;">{{chognzhitishi}}</p>
    <div style="text-align:center">
      <el-button @click="chongzhi = false" style="width: 100px;">取消</el-button>
      <el-button type="danger" @click="quchongzhi()" style="width: 100px;">充值</el-button>
      <!-- <el-button type="primary" @click="handleGm(1)" style="width: 100px;">扫码购买</el-button> -->
    </div>
  </el-dialog>

  <!-- 初始化弹框 -->
  <el-dialog :center="true" title="请选择店铺" :visible.sync="dialogVisibleadd" width="25%">
    <el-form class="findform">
      <el-form-item label="店铺名称：" style="display:flex;">
        <el-select v-model="bbid" filterable placeholder="请选择店铺" @change="handleChangedptype">
          <el-option v-for="item in options1" :key="item.id" :value="item.id" :label="item.name"/>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="danger" @click="gonext()">确定</el-button>
    </div>
  </el-dialog>
  
</section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { userIdentity, postPlaceOrderNative, payment } from '../../api/newOss';
import { statisticsewStaffList, statisticsStaffNewUserList, getFirstUser, getSecondUser, getUserOrderList,
  getUserShareList, statisticsewStaffListExport } from "../../api/attractInvestment";
import { getDpsjShopRecord, getDpsjOtherRecord, getUserReadList, getUserReadDetailedList,
  browseListAll, browseListNo, getSource, getAttrib, browseDetailedList, browseBuy, seeCustomerPhone, rechargeState } from "../../api/shopWindow";
export default {
  name: 'storeData',
  mixins: [alertTrends],
  data() {
    return {
      show3: true,
      activeName: 'fifth', // 本店客户数据
      value1: '', // 日期
      ksDate1: '', // 开始时间
      jsDate1: '', // 结束时间
      dpsmjlList: [], // 店铺扫码记录
      pageIndex1: 1,
      pageSize1: 10,
      totalRowsCount1: 0,

      partnerPhone: "", // 手机号
      value2: '', // 日期
      ksDate2: '', // 开始时间
      jsDate2: '', // 结束时间
      ygfxhkList: [], // 分享浏览数据
      pageIndex2: 1,
      pageSize2: 10,
      totalRowsCount2: 0,
      
      staffPhone: "", // 员工手机号码
      value3: '', // 日期3
      ksDate3: '', // 开始时间
      jsDate3: '', // 结束时间
      yglxsjList: [], // 员工拉新数据
      pageIndexEighth: 1,
      totalRowsCountEighth: 0,
      lxyhsShow: false, // 拉新用户数列表显隐
      ygId: '', // 员工id
      ygnc: '', // 员工昵称
      lxyhsList: [], // 拉新用户数列表
      pageIndexLxyhs: 1,
      totalRowsCountLxyhs: 0,

      newUsersDrawer: false, // 公共抽屉控制显隐
      titSix: '',   // 公共弹框标题
      pullNewOrVipList: [], // 公共抽屉列表
      pageIndexSix: 1,   // 公共列表分页
      totalRowsCountSix: 0, // 公共列表总数
      lxyhspthyId: '',
      lxyhspthyType: 2, // 默认交易笔数

      yhsjhPhone: '', // 用户手机号
      value4: '', // 日期4
      ksDate4: '', // 开始时间
      jsDate4: '', // 结束时间
      dpllsjList: [], // 店铺浏览数据
      pageIndexFour: 1,
      totalRowsCountFour: 0,

      seeUserId: '', // 用户id
      visibleSeeLlmx: false, // 查看浏览明细-抽屉
      seeLlmxList: [], // 查看浏览明细-列表
      pageIndexLlmx: 1,
      totalRowsCountLlmx: 0,
      
      value5: '', // 日期5
      ksDate5: '', // 开始时间
      jsDate5: '', // 结束时间
      lyqd: 0, // 来源渠道
      lyqdOptions: [
        {
          sourceID: 0,
          sourceName: "全部"
        },{
          sourceID: 1,
          sourceName: "员工拉新"
        },{
          sourceID: 2,
          sourceName: "创客分享"
        },{
          sourceID: 3,
          sourceName: "平台流量"
        },{
          sourceID: 4,
          sourceName: "店铺扫码"
        }
      ],
      khsx: 0, // 客户属性
      khsxOptions: [
        {
          attribID: 0,
          attribName: "全部"
        },{
          attribID: 1,
          attribName: "未购买"
        },{
          attribID: 2,
          attribName: "已购买"
        },{
          attribID: 3,
          attribName: "本店客户"
        },{
          attribID: 4,
          attribName: "限时免费"
        }
      ],
      bdkhsjList: [], // 本店客户数据
      pageIndexFive: 1,
      totalRowsCountFive: 0,
      batchliveListArr:[], // 复选框选中项
      
      llnrId: '', // 用户id
      visibleSeeLlnr: false, // 查看浏览明细-抽屉
      seeLlnrList: [], // 查看浏览明细-列表
      pageIndexLlnr: 1,
      totalRowsCountLlnr: 0,

      tabPosition: 0, // tab切换标识

      visiblePhone: false, // 重要提示&温馨提示
      titlePhone: '重要提示',
      numPhone: '', // 用户手机号

      wxsmzfVisible: false, // 请使用微信扫码支付
      wxsmzfJine: '', // 金额
      wxSmzfImg: '', // 二维码
      timer: null, // 轮询
      startTime: 0, // 初始开始请求时间
      
      priorityRecharge: false,
      owemoney: '', // 欠费金额

      dialogVisibleadd: false,
      bbid:'',  //店铺id
      bbtype: '', // 店铺类型
      options1: [],

      goumai: false, // 购买提示
      zysj: 0, // 金额
      goumaiList: [], // 购买记录
      
      chongzhi: false, // 充值提示
      chognzhitishi: '', // 提示文案
      
    }
  },
  methods: {
    // 点击tab切换
    handleClick(tab, event) {
      this.partnerPhone = '';     // 清空搜索框
      this.activeName = tab.name;
      if(tab.name=='fifth'){
        this.pageIndexFive = 1;
        this.totalRowsCountFive = 0;
        this.getBdkhsj(); // 列表5
      }
      if(tab.name=='first'){
        this.pageIndex1 = 1;
        this.totalRowsCount1 = 0;
        this.getDpsmjl(); // 列表1
      }
      if(tab.name=='second'){
        this.pageIndex2 = 1;
        this.totalRowsCount2 = 0;
        this.getYgfxhk(); // 列表2
      }
      if(tab.name=='third'){
        this.pageIndexEighth = 1;
        this.totalRowsCountEighth = 0;
        this.employeeDimensionFun(); // 列表3
      }
      if(tab.name=='fourth'){
        this.pageIndexFour = 1;
        this.totalRowsCountFour = 0;
        this.getdpllsj(); // 列表4
      }
    },
    // 店铺扫码记录 - 选择时间查询
    changeTime1() {
      if(this.value1+""=="null"){
        this.value1 = ["",""]
      }
      this.ksDate1 = this.value1[0];
      this.jsDate1 = this.value1[1];
    },
    // 分享浏览数据 - 选择时间查询
    changeTime2() {
      if(this.value2+""=="null"){
        this.value2 = ["",""]
      }
      this.ksDate2 = this.value2[0];
      this.jsDate2 = this.value2[1];
    },
    // 员工拉新数据 - 选择时间查询
    changeTime3() {
      if(this.value3+""=="null"){
        this.value3 = ["",""]
      }
      this.ksDate3 = this.value3[0];
      this.jsDate3 = this.value3[1];
    },
    // 店铺浏览数据 - 选择时间查询
    changeTime4() {
      if(this.value4+""=="null"){
        this.value4 = ["",""]
      }
      this.ksDate4 = this.value4[0];
      this.jsDate4 = this.value4[1];
    },
    // 本店客户数据 - 选择时间查询
    changeTime5() {
      if(this.value5+""=="null"){
        this.value5 = ["",""]
      }
      this.ksDate5 = this.value5[0];
      this.jsDate5 = this.value5[1];
    },
    // 导出
    onExport() {
      var addParams = {
        bbid: this.bbid, // 店铺id
        beginDate: this.ksDate3,
        endDate: this.jsDate3,
      };
      statisticsewStaffListExport(addParams).then(data => {})
    },
    // 重置
    fnReset() {
      this.staffPhone = '';
      this.value3 = '';
      this.ksDate3 = '';
      this.jsDate3 = '';
      this.lxyhsShow = false; // 隐藏拉新用户数列表
      this.employeeDimensionFun();
    },
    // 查询
    onSubmit() {
      if(this.activeName=='fifth'){
        this.pageIndexFive = 1;
        this.getBdkhsj();
      }
      if(this.activeName=='first'){
        this.pageIndex1 = 1;
        this.getDpsmjl();
      }
      if(this.activeName=='second'){
        this.pageIndex2 = 1;
        this.getYgfxhk();
      }
      if(this.activeName=='third'){
        this.pageIndexEighth = 1;
        this.employeeDimensionFun();
      }
      if(this.activeName=='fourth'){
        this.pageIndexFour = 1;
        this.getdpllsj();
      }
    },
    // 店铺扫码记录
    getDpsmjl() {
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      let addParams = {
        bbid: this.bbid, // 店铺id
        begin: this.ksDate1, // 开始时间（格式：yyyy-MM-dd）
        end: this.jsDate1, // 结束时间（格式：yyyy-MM-dd）
        pageIndex: this.pageIndex1,// 页码
        pageSize: this.pageSize1 // 每页行数
      };
      getDpsjShopRecord(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.dpsmjlList = data.resultObj.resultObj;
            this.totalRowsCount1 = data.resultObj.rowsCount;
          } else {
            this.dpsmjlList = [];
            this.totalRowsCount1 = 0;
          }
        } else {
          this.dpsmjlList = [];
          this.totalRowsCount1 = 0;
        }
      })
    },
    // 分页1
    handlePagingOne(val) {
      this.pageIndex1 = val;
      this.getDpsmjl();
    },
    // 分享浏览数据
    getYgfxhk() {
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      let addParams = {
        bbid: this.bbid, // 店铺id
        key: this.partnerPhone, // 关键字
        begin: this.ksDate2, // 开始时间（格式：yyyy-MM-dd）
        end: this.jsDate2, // 结束时间（格式：yyyy-MM-dd）
        pageIndex: this.pageIndex2,// 页码
        pageSize: this.pageSize2 // 每页行数
      };
      getDpsjOtherRecord(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.ygfxhkList = data.resultObj.resultObj;
            this.totalRowsCount2 = data.resultObj.rowsCount;
          } else {
            this.ygfxhkList = [];
            this.totalRowsCount2 = 0;
          }
        } else {
          this.ygfxhkList = [];
          this.totalRowsCount2 = 0;
        }
      })
    },
    // 分页2
    handlePagingTwo(val) {
      this.pageIndex2 = val;
      this.getYgfxhk();
    },
    // 员工拉新数据
    employeeDimensionFun(){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      let addParams = {
        bbid: this.bbid, // 店铺id
        mobile: this.staffPhone, // 员工手机号码
        beginDate: this.ksDate3,
        endDate: this.jsDate3,
        pageIndex: this.pageIndexEighth,
        pageSize: 10,
      };
      statisticsewStaffList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.yglxsjList = data.resultObj.resultObj;
            this.totalRowsCountEighth = data.resultObj.rowsCount;
          } else {
            this.yglxsjList = []
          }
        } else {
          this.yglxsjList = []
        }
      })
    },
    // 分页3
    handleTabEighth(val) {
      this.pageIndexEighth = val;
      this.employeeDimensionFun();
    },
    // 点击拉新用户数
    lxyhsClick(row, type) {
      this.ygId = row.id; // 获取员工id
      this.ygnc = row.name; // 获取列表员工昵称
      this.lxyhsShow = true; // 显示拉新用户数列表
      this.pageIndexLxyhs = 1;
      this.getLxyhs(type);
    },
    // 获取拉新用户数列表
    getLxyhs(type){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      let addParams = {
        staffId: this.ygId, // 员工id
        shopId: this.bbid, // 店铺id
        beginDate: this.ksDate3,
        endDate: this.jsDate3,
        pageIndex: this.pageIndexLxyhs,
        pageSize: 10,
        isVip: type, // 是否VIP 0=否 1=是
      };
      getFirstUser(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.lxyhsList = data.resultObj.resultObj;
            this.totalRowsCountLxyhs = data.resultObj.rowsCount;
          } else {
            this.lxyhsList = []
          }
        } else {
          this.lxyhsList = []
        }
      })
    },
    // 拉新用户数-分页
    handlelxyhsList(val) {
      this.pageIndexLxyhs = val;
      this.getLxyhs();
    },
    // 交易笔数+拉新用户数+交易笔数+分享被浏览次数
    pullNewFun(rowId, type){
      this.lxyhspthyId = rowId;
      this.lxyhspthyType = type;
      if(this.lxyhspthyType==2) {
        this.titSix = '交易笔数';
      }
      if(this.lxyhspthyType==3) {
        this.titSix = '拉新用户数';
      }
      if(this.lxyhspthyType==4) {
        this.titSix = '交易笔数';
      }
      if(this.lxyhspthyType==5) {
        this.titSix = '分享被浏览明细';
      }
      this.pageIndexSix = 1;
      this.hyjybslxyhsjybsfxbllcs(type);
    },
    // 公共抽屉列表 分页
    hyjybslxyhsjybsfxbllcs(type) {
      let addParams = {
        userId: this.lxyhspthyId, // 员工id
        shopId: this.bbid, // 店铺id
        beginDate: this.ksDate3, // 查询开始日期
        endDate: this.jsDate3, // 查询截止日期
        pageIndex: this.pageIndexSix,
        pageSize: 10,
        // userId: this.bbid,   //进入模块时下拉框选择的店铺id
        // isVip: this.lxyhspthyType,   // 0=拉新用户数、1=平台会员
        // dateType: 0,
        // maId: this.maIdSix, // 联盟id int类型   （列表左上方下拉列表选中的联盟id）
      };
      let thisApi = type==2||type==4?getUserOrderList:type==3?getSecondUser:getUserShareList;
      thisApi(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.pullNewOrVipList = data.resultObj.resultObj;
            this.totalRowsCountSix = data.resultObj.rowsCount;
          } else {
            this.pullNewOrVipList = []
          }
        } else {
          this.pullNewOrVipList = []
        }
      })
      this.newUsersDrawer = true;
    },
    // 公共抽屉 分页
    handleTabSix(val) {
      this.pageIndexSix = val;
      this.hyjybslxyhsjybsfxbllcs();
    },
    
    // 店铺浏览数据
    getdpllsj(){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      let addParams = {
        bbid: this.bbid, // 店铺id
        key: this.yhsjhPhone, // 手机号
        beginDate: this.ksDate4, // 开始时间
        endDate: this.jsDate4, // 结束时间
        pageIndex: this.pageIndexFour, // 页码
        pageSize: 10, // 条数
      };
      getUserReadList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.dpllsjList = data.resultObj.resultObj;
            this.totalRowsCountFour = data.resultObj.rowsCount;
          } else {
            this.dpllsjList = []
          }
        } else {
          this.dpllsjList = []
        }
      })
    },
    // 分页4
    handleCurrentChange(val) {
      this.pageIndexFour = val;
      this.getdpllsj();
    },
    // 切换全部 || 未付费
    changeTheme(val) {
      console.log(val);
      this.pageIndexFive = 1;
      this.getBdkhsj();
    },
    // 本店客户数据
    getBdkhsj(){
      if(!this.bbid) {
        this.showAlert('请重新打开本功能，并选择一家店铺');
        return false;
      }
      let addParams = {
        shopid: this.bbid, // 店铺id
        begindate: this.ksDate5, // 开始时间
        enddate: this.jsDate5, // 结束时间
        sourceid: this.lyqd, // 来源渠道
        attributeid: this.tabPosition==0?this.khsx:1, // 客户属性
        pageindex: this.pageIndexFive, // 页码
        pagesize: 10, // 条数
      };
      // let thisApi = this.tabPosition==0?browseListAll:browseListNo;
      browseListAll(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.bdkhsjList = data.resultObj.list;
            this.totalRowsCountFive = data.resultObj.totalcount;
          } else {
            this.bdkhsjList = [];
            this.totalRowsCountFive = 0;
          }
        } else {
          this.bdkhsjList = [];
          this.totalRowsCountFive = 0;
        }
      })
    },
    // 分页5
    currentChangeFive(val) {
      this.pageIndexFive = val;
      this.getBdkhsj();
    },
    // 查看浏览明细
    handleSeeLlmx(row) {
      this.seeUserId = row.userId // 用户id
      this.getLlmx();
      this.visibleSeeLlmx = true;
    },
    // 查看浏览明细-列表
    getLlmx(){
      let addParams = {
        bbid: this.bbid, // 店铺id
        userId: this.seeUserId, // 用户id
        beginDate: this.ksDate4, // 开始时间
        endDate: this.jsDate4, // 结束时间
        pageIndex: this.pageIndexLlmx, // 页码
        pageSize: 10, // 条数
      };
      getUserReadDetailedList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.seeLlmxList = data.resultObj.resultObj;
            this.totalRowsCountLlmx = data.resultObj.rowsCount;
          } else {
            this.seeLlmxList = []
          }
        } else {
          this.seeLlmxList = []
        }
      })
    },
    // 查看浏览明细-分页
    handleLlmx(val) {
      this.pageIndexLlmx = val;
      this.getLlmx();
    },
    // 查看浏览内容
    handleSeeLlnr(row) {
      this.llnrId = row.userid // 用户id
      this.pageIndexLlnr = 1;
      this.getLlnr();
      this.visibleSeeLlnr = true;
    },
    // 查看浏览内容-列表
    getLlnr(){
      let addParams = {
        // bbid: this.bbid, // 店铺id
        bbid: 0, // 备注说明: 0 查全部店铺下的数据
        userId: this.llnrId, // 用户id
        beginDate: this.ksDate5, // 开始时间
        endDate: this.jsDate5, // 结束时间
        pageIndex: this.pageIndexLlnr, // 页码
        pageSize: 10, // 条数
      };
      browseDetailedList(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.seeLlnrList = data.resultObj.resultObj;
            this.totalRowsCountLlnr = data.resultObj.rowsCount;
          } else {
            this.seeLlnrList = []
          }
        } else {
          this.seeLlnrList = []
        }
      })
    },
    // 查看浏览内容-分页
    handleLlnr(val) {
      this.pageIndexLlnr = val;
      this.getLlnr();
    },
    // 复选框
    handleSelectionChange(val) {
      this.goumaiList = val; // 赋值选中行id
      this.batchliveListArr = [];
      val.forEach(element => {
        this.batchliveListArr.push(element.scid);
      });
    },
    // 购买客户
    buyingCustomers(row) {
      if(row){
        this.scid = row.scid;
        this.goumaiList = [row]; // 赋值选中行
      }else{
        if(this.batchliveListArr.length == 0){
          this.showAlert('请至少选择一条数据');
          return false
        }
      }
      
      let scid = this.scid?this.scid:this.batchliveListArr.join('|')
      let obj = {
        attach: 'buyshopcustomer,' + scid,
        price: 0, // 支付金额 单位：元 （店铺分享赚钱必传）
        operatorid: localStorage.Id, // 操作人
        isconfirm: 0, // 是否确认支付 0=否 1=是 （非确认支付只返回支付金额 单位：元）
      };
      payment(obj,3,this.bbid).then(data => {
        if (data.resultCode == 1) {
          this.goumai = true;
          this.zysj = data.resultObj; // 返回金额 - 待确认支付：返回待支付金额 单位：元 确认支付：>0表示成功
        }else if(data.resultCode == 4){
          this.chongzhi=true; // 充值提示
          this.chognzhitishi=data.resultObj; // 提示文案
        }else{
          this.showAlert(data.resultMsg);
        }
      });
    },
    // 确定购买 && 微信扫码购买
    handleGm(type) {
      let isrechargepay = type==0?0:1
      let scid = this.scid?this.scid:this.batchliveListArr.join('|')
      this.goumai=false;
      let obj = {
        // attach: 'buyshopcustomer,' + shopid +','+ operatorid +','+ isrechargepay +','+ customerid
        // isrechargepay说明：在列表中直接点击购买操作，isrechargepay传0，toast弹窗后点击微信扫码购买，isrechargepay传1
        // isrechargepay=是否充值购买 0=否 1=是
        // 如购买多个客户，用竖线隔开，customerid取列表接口返回的scid
        // attach: 'buyshopcustomer,' + this.bbid +','+ localStorage.Id +','+ isrechargepay +','+ scid,
        attach: 'buyshopcustomer,' + scid,
        price: 0, // 支付金额 单位：元 （店铺分享赚钱必传）
        operatorid: localStorage.Id, // 操作人
        isconfirm: 1, // 是否确认支付 0=否 1=是 （非确认支付只返回支付金额 单位：元）
      };
      
      payment(obj,3,this.bbid).then(data => {
        if (data.resultCode == 1) {
          // this.zysj = data.resultObj; // 返回金额 - 待确认支付：返回待支付金额 单位：元 确认支付：>0表示成功
          this.showAlert('购买成功', 'success');
          this.goumai = false;
          this.getBdkhsj();
        }else if(data.resultCode == 4){
          this.chongzhi=true; // 充值提示
          this.chognzhitishi=data.resultObj; // 提示文案
        }else{
          this.showAlert(data.resultMsg);
        }
      });
      
      // postPlaceOrderNative(obj).then(data => {
      //   if (data.resultCode == 1) {
      //     if(type==1){
      //       this.wxsmzfVisible = true;
      //       this.chongzhi = false;
      //       this.monitorid = data.resultObj.monitorid; // 轮询接口入参id
      //       this.wxsmzfJine = data.resultObj.price; // 金额（单位0）
      //       this.wxSmzfImg = data.resultObj.qrCode; // resultCode=1时返回base64格式二维码图片
      //       this.startTime = new Date().getTime() // 获取触发轮询时的时间
      //       this.inquireData() // 调用轮询接口,开始进行轮询
      //     }else{
      //       if(data.resultMsg == 'false') {
      //         this.chongzhi = true; // 充值提示
      //         this.goumai = false;
      //       } else {
      //         this.showAlert('购买成功', 'success');
      //         this.goumai = false;
      //         this.getBdkhsj();
      //       }
      //     }
      //   } else {
      //     this.showAlert(data.resultMsg);
      //     return false;
      //   }
      // });

      // let obj = {
      //   businessID: this.bbid, // 店铺ID
      //   browseID: this.batchliveListArr, // ID 数组
      // };
      // browseBuy(obj).then(data => {
      //   if (data.resultCode == 1) {
      //     if(data.resultMsg == 'false') {
      //       this.chongzhi = true; // 充值提示
      //       this.goumai = false;
      //     } else {
      //       this.showAlert('购买成功', 'success');
      //       this.goumai = false;
      //       this.getBdkhsj();
      //     }
      //   } else {
      //     this.showAlert(data.resultMsg);
      //     return false;
      //   }
      // });
    },
    // 去充值
    quchongzhi(){
      this.$router.push({
        path: "/vmacount",
        query: { shopid: this.bbid }
      });
    },
    // 去充值
    gotoCz () {
      this.$router.push({path: "/paidPromotion"});
    },
    // 关闭弹框
    closeWxsmzf(){
      this.wxsmzfVisible = false; // 二维码弹窗消失
      clearTimeout(this.timer)
    },
    // 轮询请求
    inquireData() {
      const reload = () => {
        clearTimeout(this.timer) // 清除定时器
        // 超过30分钟则停止轮询
        if (new Date().getTime() - this.startTime > 5 * 60 * 1000) {
          clearTimeout(this.timer)
          return
        }
        // 3s一次, 轮询中
        this.timer = setTimeout(() => {
          this.inquireData() // 调用轮询
        }, 1000)
      }
      let lxObj = { id: this.monitorid, }
      rechargeState(lxObj).then(res => {
        if (res && res.resultCode === 1) {
          // true=成功、false=失败
          if(res.resultObj) {
            this.wxsmzfVisible = false; // 二维码弹窗消失
            this.chongzhi = false;
            this.showAlert('购买成功', 'success');
            this.getBdkhsj();
          } else {
            reload() // 没成功,调用轮询
          }
        } else {
          reload() // 没成功,调用轮询
        }
      }).catch(err => {
        reload() // 请求错误,也继续轮询
      })
    },
    // 查看电话号码
    seePhone(row){
      let addParams = {
        id: row.userid, // 列表用户id
        shopid: this.bbid, // 店铺id
      };
      seeCustomerPhone(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            this.numPhone = data.resultObj; // 用户手机号
            this.visiblePhone = true;
            this.titlePhone = '重要提示';
          }else if(data.resultCode == 4){
            this.priorityRecharge = true;
            this.owemoney = data.resultObj; // 欠费金额
          } else {
            this.titlePhone = '温馨提示';
            this.visiblePhone = true;
          }
        }
      })
    },
    // 来源渠道
    sourceChannel() {
      // getSource('obj').then(data => {
      //   if (data.resultCode == 1) {
      //     this.lyqdOptions = data.resultObj;
      //     this.lyqdOptions.unshift({
      //       sourceID: 0,
      //       sourceName: "全部"
      //     });
      //   }
      // });
    },
    // 客户属性
    clientProperty() {
      // getAttrib('obj').then(data => {
      //   if (data.resultCode == 1) {
      //     this.khsxOptions = data.resultObj;
      //     this.khsxOptions.unshift({
      //       attribID: 0,
      //       attribName: "全部"
      //     });
      //   }
      // });
    },
    
    // 商家联盟获取用户身份以及可查看的店铺
    tankuang(){
      let addParams = {
        userId: localStorage.Id, // 当前登陆人id
      };
      userIdentity(addParams).then(data => {
        if (data) {
          if (data.resultCode == 1) {
            if(data.resultObj.length>1){
              // this.bbid = data.resultObj[0].id; // 店铺id
              // this.gonext();
              this.dialogVisibleadd = true;
              this.options1 = data.resultObj;
            } else { // 默认选中第一个店铺不显示弹框
              this.dialogVisibleadd = false;
              this.bbid = data.resultObj[0].id; // 店铺id
              this.bbtype = data.resultObj[0].shopType; // 店铺类型
              this.gonext();
            }
          }else{
            this.showAlert('请先在店铺信息功能中创建自己店铺');
            return false;
          }
        }
      })
    },
    // 获取店铺类型
    handleChangedptype(val) {
      this.options1.filter(item => {
        if(item.id == val){
          this.bbtype = item.shopType;
        }
      })
    },
    gonext(){
      console.log(this.bbid)
      if(this.bbid == ""){
        this.showAlert('请选择店铺名称');
        return false
      }
      // this.getDpsmjl(); // 查询列表
      this.getBdkhsj(); // 本店客户数据
      this.sourceChannel(); // 来源渠道
      this.clientProperty(); // 客户属性
      this.dialogVisibleadd = false;
    },
  },
  created() {
    this.tankuang(); // 商家联盟获取用户身份以及可查看的店铺
  }
}
</script>
<style scoped>

</style>


// WEBPACK FOOTER //
// storeData.vue?1e65540a